exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-container[data-v-e19618ec]{max-height:85px;min-height:85px;margin-bottom:5px;overflow:hidden}.img-fluid[data-v-e19618ec]{width:90px!important;height:92px!important;-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important}", ""]);

// exports
